import { useMemo } from 'react'
import { cssUrl } from '@/lib/coachPhoto'
import { useAuthContext } from './data/useAuthContext'
import { useCurrentUser } from './useCurrentUser'
import { useOwnCoachPhoto } from './useOwnCoachPhoto'

/** Returns the appearance config for Clerk's UserButton component. */
export function useUserButtonAppearance() {
  const { user: userDetails } = useCurrentUser()
  const { data: authContext } = useAuthContext()
  const coachPhoto = useOwnCoachPhoto()

  return useMemo(() => {
    const ssoEmailHide = userDetails?.sso_enabled
      ? { userPreviewSecondaryIdentifier: { display: 'none' as const } }
      : {}

    // ENG-3270: the legacy modal is Clerk's own UI, so hiding the Security tab
    // is the only lever we have over it. Without password_auth_disabled here, a
    // learner in a flagged organization on this path still gets Clerk's
    // password management, which the backend would then refuse.
    const shouldHideSecurityTab =
      userDetails === undefined || userDetails?.sso_enabled || !!authContext?.password_auth_disabled

    // A coach's photo is drawn over Clerk's avatar rather than uploaded to Clerk.
    const avatarBox = coachPhoto
      ? { backgroundImage: cssUrl(coachPhoto), backgroundSize: 'cover', backgroundPosition: 'center' }
      : {}
    const avatarImage = coachPhoto ? { visibility: 'hidden' as const } : {}

    return {
      elements: {
        ...ssoEmailHide,
        userButtonAvatarBox: avatarBox,
        userButtonAvatarImage: avatarImage,
        userPreviewAvatarBox: avatarBox,
        userPreviewAvatarImage: avatarImage,
        navbarButton__account: { display: 'none' as const },
        profileSection__profile: { display: 'none' as const },
        profileSection__username: { display: 'none' as const },
        profileSection__emailAddresses: { display: 'none' as const },
        profileSection__phoneNumbers: { display: 'none' as const },
        profileSection__connectedAccounts: { display: 'none' as const },
        profileSection__enterpriseAccounts: { display: 'none' as const },
        profileSection__activeDevices: { display: 'none' as const },
        profileSection__danger: { display: 'none' as const },
        profilePage__account: { display: 'none' as const },
        ...(shouldHideSecurityTab
          ? {
              navbarButton__security: { display: 'none' as const },
              profilePage__security: { display: 'none' as const },
            }
          : {}),
      },
    }
  }, [userDetails, authContext, coachPhoto])
}
